import { render, staticRenderFns } from "./addNewQuestion.vue?vue&type=template&id=a7e4aede&scoped=true&"
import script from "./addNewQuestion.vue?vue&type=script&lang=js&"
export * from "./addNewQuestion.vue?vue&type=script&lang=js&"
import style0 from "./addNewQuestion.vue?vue&type=style&index=0&id=a7e4aede&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e4aede",
  null
  
)

export default component.exports